<ng-container
    *ngIf="
        (property | isSelectFilter) ||
        (property | isMultiselectFilter) ||
        (property | isPoliticalWindowsConfigTierFilter) ||
        (property | isGroupSelectFilter) ||
        (property | isGroupMultiselectFilter)
    "
>
    <div class="inline-form-options">
        <mat-button-toggle-group
            *ngIf="property.isButtons"
            attr.data-cy="filter-input-buttons-{{ property.Key }}"
            [(ngModel)]="property.Value"
            [multiple]="property | isMultiselectFilter"
            id="{{ property.Key }}"
            [disabled]="disabled ? disabled : null"
        >
            <mat-button-toggle
                attr.data-cy="filter-input-buttons-{{ property.Key }}-{{ option }}"
                *ngFor="let option of property.filteredOptions | async; let i = index"
                [value]="option"
                [ngStyle]="{ display: !property.partialButtons || i < property.partialButtons ? '' : 'none' }"
            >
                {{ option | displayText }}
            </mat-button-toggle>
        </mat-button-toggle-group>
        <mat-form-field
            [color]="property.isWarn ? 'warn' : 'primary'"
            [appearance]="appearance ?? 'fill'"
            [ngClass]="[
                errorStateMatcher?.validationClass ?? 'valid',
                (property.filteredOptions | async)?.length > property.partialButtons ? 'select-filter-with-buttons' : ''
            ]"
            subscriptSizing="dynamic"
            attr.data-cy="filter-input-select-{{ property.Key }}"
            class="select-filter"
            *ngIf="
                ((property | isSelectFilter) ||
                    (property | isMultiselectFilter) ||
                    (property | isGroupSelectFilter) ||
                    (property | isGroupMultiselectFilter) ||
                    (property | isPoliticalWindowsConfigTierFilter)) &&
                !property.isButtons
            "
            (keydown)="keyPress($event)"
        >
            <span
                matPrefix
                *ngIf="!property.isLoaded || property.isLoading"
                ><mat-spinner [diameter]="15"></mat-spinner
            ></span>
            <span
                matPrefix
                *ngIf="property.hasIcon && ((property.isLoaded && !property.isLoading) || !property.isAsync)"
            >
                <i class="{{ property.iconClass }}"></i>
            </span>
            <app-filter-input
                *ngIf="property.booleanFilter"
                attr.data-cy="filter-input-boolean-{{ property.Key }}"
                [property]="property.booleanFilter"
                (valueChanged)="valueChanged.emit($event)"
                class="select-filter-checkbox"
            ></app-filter-input>
            <div class="add-custom-daypart">
                <a
                    *ngIf="property?.customButton"
                    attr.data-cy="filter-input-custom-button-{{ property.Key }}"
                    (click)="property?.customCallback(); $event.stopPropagation()"
                    class="button is-small is-primary pencil-icon"
                    [title]="property?.customTitle"
                >
                    <i
                        class="fas fa-pencil-alt"
                        class="fas fa-pencil-alt"
                    ></i>
                </a>
            </div>
            <mat-label>{{ property.displayKey ? property.defaultName + ' ' + property.Key : '' }} </mat-label>
            <mat-select
                [panelClass]="'ag-custom-component-popup select-overlay lower-select-panel'"
                [panelWidth]="null"
                [multiple]="(property | isMultiselectFilter) || (property | isGroupMultiselectFilter)"
                #selectFilter
                id="{{ property.Key }}"
                [errorStateMatcher]="errorStateMatcher"
                [(ngModel)]="property.Value"
                [aria-label]="property.defaultName + ' ' + property.Key"
                [disabled]="disabled ? disabled : null"
                [matTooltipDisabled]="!disabled"
                [matTooltip]="property.disabledTooltip"
                matTooltipClass="tooltip"
                [compareWith]="property.compareFn"
                (opened)="openedChange()"
                (closed)="closedChange()"
                (selectionChange)="errorStateMatcher?.markAsInteracted()"
                (blur)="errorStateMatcher?.markAsInteracted()"
            >
                <mat-select-trigger *ngIf="((property | isMultiselectFilter) || (property | isGroupMultiselectFilter)) && property.Value"
                    >{{ (property.Value?.length > property.triggerLength && property.triggerText) || property.Value | displayText }}
                </mat-select-trigger>
                <mat-select-trigger *ngIf="!((property | isMultiselectFilter) || (property | isGroupMultiselectFilter)) && property.Value"
                    >{{ property.Value | displayText }}
                </mat-select-trigger>
                <div class="select-container">
                    <ng-container *ngIf="property.isFilterable">
                        <!-- this mat option makes it so the filter will open even if there are no selectable options -->
                        <mat-option style="display: none"></mat-option>
                        <mat-form-field
                            [color]="property.isWarn ? 'warn' : 'primary'"
                            class="width-100-pct"
                        >
                            <input
                                #search
                                attr.data-cy="filter-input-search-field-{{ property.Key }}"
                                autocomplete="off"
                                placeholder="Search"
                                aria-label="Search"
                                matInput
                                [formControl]="searchTextboxControl"
                                (keydown)="keyPress($event)"
                            />
                            <button
                                [disableRipple]="true"
                                attr.data-cy="filter-input-search-button-{{ property.Key }}"
                                *ngIf="search.value"
                                matSuffix
                                mat-icon-button
                                class="is-flex justify-center"
                                aria-label="Clear"
                                (click)="clearSearch()"
                            >
                                <i
                                    class="fas fa-times"
                                    style="font-size: 1.5rem"
                                ></i>
                            </button>
                        </mat-form-field>
                    </ng-container>
                    <ng-container *ngIf="(property | isMultiselectFilter) || (property | isGroupMultiselectFilter)">
                        <mat-checkbox
                            *ngIf="property.canSelectAll"
                            attr.data-cy="filter-input-select-all-{{ property.Key }}"
                            class="mat-option"
                            [(checked)]="property.isAllSelected"
                            [(indeterminate)]="property.isSubsetSelected"
                            (change)="selectAll($event)"
                            >Select All
                        </mat-checkbox>
                    </ng-container>
                    <mat-option
                        *ngIf="property.callbackDisplayText"
                        attr.data-cy="filter-input-callback-{{ property.Key }}"
                        class="callback-option"
                        (click)="property.callbackOption()"
                        >{{ property.callbackDisplayText }}
                    </mat-option>
                    <mat-option *ngIf="property.isClearable">None</mat-option>
                    <ng-container *ngIf="(property.filteredOptions | async)?.length; else emptySearchText">
                        <!-- TODO: Figure out a way to get this to work without breaking de-selection -->
                        <!--                        <ng-container-->
                        <!--                            *ngIf="((Property.filteredOptions | async) || [])!.length > 100000">-->
                        <!--                            &lt;!&ndash; inline styling because height MUST be itemSize * 6&ndash;&gt;-->
                        <!--                            <cdk-virtual-scroll-viewport class="overflowX-hidden" [orientation]="'vertical'"-->
                        <!--                                                         [itemSize]="30" [style.height.px]="6*30" [minBufferPx]="400" [maxBufferPx]="1000">-->
                        <!--                                <ng-container *ngIf="Property.Type === 'Select'">-->
                        <!--                                    <mat-option (onSelectionChange)="selectionChange($event)"-->
                        <!--                                                *cdkVirtualFor="let option of Property.filteredOptions | async"-->
                        <!--                                                [value]="option"-->
                        <!--                                                [innerHtml]="option | displayText">-->
                        <!--                                    </mat-option>-->
                        <!--                                </ng-container>-->
                        <!--                                <ng-container *ngIf="Property.Type === 'MultiSelect'">-->
                        <!--                                    <mat-option (onSelectionChange)="selectionChange($event)"-->
                        <!--                                                *cdkVirtualFor="let option of Property.filteredOptions | async"-->
                        <!--                                                [value]="option">-->
                        <!--                                        {{option | displayText}}-->
                        <!--                                    </mat-option>-->
                        <!--                                </ng-container>-->
                        <!--                            </cdk-virtual-scroll-viewport>-->
                        <!--                        </ng-container>-->
                        <ng-container>
                            <!--                       <ng-container-->
                            <!--                            *ngIf="((Property.filteredOptions | async) || [])!.length <= 100000"-->
                            <!--                        >-->

                            <ng-container
                                *ngIf="
                                    ((property | isPoliticalWindowsConfigTierFilter) && !property.showTierGroup) ||
                                    (property | isSelectFilter)
                                "
                            >
                                <mat-option
                                    (onSelectionChange)="selectionChange($event)"
                                    attr.data-cy="filter-input-select-option"
                                    *ngFor="let option of property.filteredOptions | async; let i = index"
                                    [value]="option"
                                    [disabled]="disabledOptions?.includes(option)"
                                    [ngStyle]="{ display: !property.partialButtons || i >= property.partialButtons ? '' : 'none' }"
                                >
                                    {{ option | displayText }}
                                </mat-option>
                            </ng-container>

                            <ng-container *ngIf="(property | isPoliticalWindowsConfigTierFilter) && property.showTierGroup">
                                <mat-optgroup
                                    label="*Political"
                                    *ngIf="getPoliticalOptions(property.filteredOptions | async).length > 0"
                                >
                                    <mat-option
                                        (onSelectionChange)="selectionChange($event)"
                                        attr.data-cy="filter-input-select-option"
                                        *ngFor="let option of getPoliticalOptions(property.filteredOptions | async); let i = index"
                                        [value]="option"
                                    >
                                        {{ option | displayText }}
                                    </mat-option>
                                </mat-optgroup>
                                <mat-optgroup label="*Dynamic">
                                    <mat-option
                                        (onSelectionChange)="selectionChange($event)"
                                        attr.data-cy="filter-input-select-option"
                                        *ngFor="let option of getDynamicOptions(property.filteredOptions | async); let i = index"
                                        [value]="option"
                                    >
                                        {{ option | displayText }}
                                    </mat-option>
                                </mat-optgroup>
                                <mat-optgroup
                                    label="*PCode"
                                    *ngIf="checkPCodeTierAvailability(property.filteredOptions | async) && property.showPcodes"
                                >
                                    <mat-option
                                        (onSelectionChange)="selectionChange($event)"
                                        attr.data-cy="filter-input-select-option"
                                        *ngFor="let option of getPCodeOptions(property.filteredOptions | async); let i = index"
                                        [value]="option"
                                    >
                                        {{ option | displayText }}
                                    </mat-option>
                                </mat-optgroup>
                            </ng-container>

                            <ng-container *ngIf="property | isGroupMultiselectFilter">
                                <ng-container *ngFor="let group of property.filteredOptions | async | groupItems">
                                    @if ((property.filteredOptions | async | groupItems).length > 1) {
                                        @if (group.items[0].group) {
                                            <mat-optgroup
                                                [label]="group.name || ''"
                                                [class.collapsible]="collapsible"
                                                [class.collapsed]="collapsible && isGroupCollapsed(group.name)"
                                                (click)="collapsible ? toggleGroup(group.name, $event) : null"
                                            >
                                                <ng-container *ngIf="!collapsible || !isGroupCollapsed(group.name)">
                                                    <mat-option
                                                        (onSelectionChange)="selectionChange($event)"
                                                        attr.data-cy="filter-input-multiselect-option-{{ property.Key }}-{{ option }}"
                                                        [value]="option"
                                                        [disabled]="isOptionDisabled(option)"
                                                        [class.highlight]="option.isUpdatedRecently"
                                                        *ngFor="let option of group.items"
                                                    >
                                                        {{ option | displayText }}
                                                    </mat-option>
                                                </ng-container>
                                            </mat-optgroup>
                                        } @else {
                                            <mat-option
                                                (onSelectionChange)="selectionChange($event)"
                                                attr.data-cy="filter-input-multiselect-option-{{ property.Key }}-{{ option }}"
                                                [value]="option"
                                                [disabled]="isOptionDisabled(option)"
                                                [class.highlight]="option.isUpdatedRecently"
                                                *ngFor="let option of group.items"
                                            >
                                                {{ option | displayText }}
                                            </mat-option>
                                        }
                                    }

                                    <ng-container *ngIf="(property.filteredOptions | async | groupItems).length === 1">
                                        <mat-option
                                            (onSelectionChange)="selectionChange($event)"
                                            attr.data-cy="filter-input-multiselect-option-{{ property.Key }}-{{ option }}"
                                            [value]="option"
                                            [disabled]="isOptionDisabled(option)"
                                            [class.highlight]="option.isUpdatedRecently"
                                            *ngFor="let option of group.items"
                                        >
                                            {{ option | displayText }}
                                        </mat-option>
                                    </ng-container>
                                </ng-container>
                            </ng-container>

                            <ng-container *ngIf="property | isGroupSelectFilter">
                                <ng-container *ngIf="property.filteredOptions | async | groupItems as groups">
                                    <ng-container *ngFor="let group of groups">
                                        <mat-optgroup
                                            *ngIf="groups.length > 1 && group.items[0].group; else flatOptions"
                                            [label]="group.name || ''"
                                        >
                                            <mat-option
                                                (onSelectionChange)="selectionChange($event)"
                                                attr.data-cy="filter-input-select-option"
                                                *ngFor="let option of group.items"
                                                [value]="option"
                                            >
                                                {{ option | displayText }}
                                            </mat-option>
                                        </mat-optgroup>
                                        <ng-template #flatOptions>
                                            <mat-option
                                                (onSelectionChange)="selectionChange($event)"
                                                attr.data-cy="filter-input-select-option"
                                                *ngFor="let option of group.items"
                                                [value]="option"
                                            >
                                                {{ option | displayText }}
                                            </mat-option>
                                        </ng-template>
                                    </ng-container>
                                </ng-container>
                            </ng-container>

                            <ng-container *ngIf="property | isMultiselectFilter">
                                <div *ngIf="!property.optionsDeletable">
                                    <mat-option
                                        (onSelectionChange)="selectionChange($event)"
                                        attr.data-cy="filter-input-multiselect-option-{{ property.Key }}-{{ option }}"
                                        [value]="option"
                                        [disabled]="isOptionDisabled(option)"
                                        [class.highlight]="option.isUpdatedRecently"
                                        *ngFor="let option of property.filteredOptions | async; let i = index"
                                        [ngStyle]="{ display: !property.partialButtons || i >= property.partialButtons ? '' : 'none' }"
                                    >
                                        {{ option | displayText }}
                                    </mat-option>
                                </div>
                                <div *ngIf="property.optionsDeletable">
                                    <div
                                        class="deletable-option"
                                        *ngFor="let option of property.filteredOptions | async; let i = index"
                                    >
                                        <mat-option
                                            (onSelectionChange)="selectionChange($event)"
                                            class="option-checkbox"
                                            attr.data-cy="filter-input-multiselect-option-{{ property.Key }}-{{ option }}"
                                            [value]="option"
                                            [disabled]="disabledOptions?.includes(option)"
                                            [class.highlight]="option.isUpdatedRecently"
                                            [ngStyle]="{ display: !property.partialButtons || i >= property.partialButtons ? '' : 'none' }"
                                        >
                                            {{ option | displayText }}
                                        </mat-option>
                                        <a
                                            *ngIf="!option.isGlobal"
                                            (click)="deleteItem(option)"
                                        >
                                            <span class="icon margin-left-half-em margin-right-half-em saved-options-icon">
                                                <i
                                                    class="fa-2x margin-left-half-em fas fa-trash-alt"
                                                    aria-hidden="true"
                                                ></i>
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </div>
                <app-button
                    [buttonText]="property?.createPoliticalWindowDisplayText"
                    *ngIf="property.showCreatePoliticalWindow"
                    (buttonClick)="property.createPoliticalWindow()"
                    [class]="'apply-button'"
                    [type]="'flat'"
                    [icon]="'fa-plus'"
                />
            </mat-select>
            <mat-hint>{{ property.hint }}</mat-hint>
            <mat-error *ngIf="property.validationError">{{ property.validationError }}</mat-error>
        </mat-form-field>
    </div>
</ng-container>

<ng-template #emptySearchText>
    <ng-container
        *ngIf="
            (property | isSelectFilter) ||
            (property | isMultiselectFilter) ||
            (property | isGroupSelectFilter) ||
            (property | isGroupMultiselectFilter)
        "
    >
        <mat-optgroup
            *ngIf="
                ((property.filteredOptions | async) === null || (property.filteredOptions | async)?.length === 0) && !isSearching;
                else searching
            "
        >
            <div>{{ searchTextboxControl.value ? 'No Results Found!' : property.emptySearchText }}</div>
        </mat-optgroup>
    </ng-container>
</ng-template>

<ng-template #searching>
    <mat-optgroup>
        <div>Searching...</div>
    </mat-optgroup>
</ng-template>
